<template>
  <div class="">Exam card</div>
</template>

<script>
export default {
  name: "examCard",
};
</script>

<style scoped></style>
